export default __webpack_public_path__ + "static/media/subscription.6b081b55.PNG";